import { render } from "./FormPagination.vue?vue&type=template&id=c478ea8a"
import script from "./FormPagination.vue?vue&type=script&setup=true&lang=js"
export * from "./FormPagination.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Atoms/FormPagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c478ea8a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c478ea8a', __exports__)) {
    api.reload('c478ea8a', __exports__)
  }
  
  module.hot.accept("./FormPagination.vue?vue&type=template&id=c478ea8a", () => {
    api.rerender('c478ea8a', render)
  })

}


export default __exports__